import { CreateOrderParameters } from '@/apis';

const WEBHOOK_URL =
  'https://hooks.slack.com/services/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';

const 토스페이먼츠_에러_발생 = (
  parameters: CreateOrderParameters,
  methods: string | undefined,
  errorMsg: string,
  customer_access_token?: string,
  channel?: string,
) => {
  const messageBlocks = [
    {
      type: 'rich_text',
      elements: [
        {
          type: 'rich_text_section',
          elements: [
            {
              type: 'text',
              text: `${errorMsg ?? '-'}`,
              style: {
                bold: true,
              },
            },
          ],
        },
      ],
    },
    {
      type: 'context',
      elements: [
        { type: 'plain_text', text: `결제수단 : ${methods ?? '-'}`, emoji: true },
        { type: 'plain_text', text: `구매자명 : ${parameters.buyer_name}`, emoji: true },
        { type: 'plain_text', text: `구매자 연락처 : ${parameters.buyer_phone}`, emoji: true },
        { type: 'plain_text', text: `구매자 토큰 : ${customer_access_token}`, emoji: true },
        {
          type: 'plain_text',
          text: `user-agent : ${window.navigator.userAgent ?? '-'}`,
          emoji: true,
        },
      ],
    },
  ];

  return {
    webHookURL: WEBHOOK_URL,
    message: [
      {
        color: '#f2c744',
        blocks: messageBlocks,
      },
    ],
    channel: channel ?? 'bot',
    username: '토스페이먼츠 에러 발생',
    botIconURL: 'https://i.ibb.co/wJJnQZS/alert.png',
  };
};

export default 토스페이먼츠_에러_발생;
